import React, { useCallback, useRef } from "react";
import { useJsApiLoader, Autocomplete } from "@react-google-maps/api";
import TextField from "@mui/material/TextField";

const libraries = ["places"];

const AddressAutocomplete = ({
  fieldPrefix,
  setFieldValue,
  name,
  value,
  onChange,
  ...textFieldProps
}) => {
  const autocompleteRef = useRef(null);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "",
    libraries,
  });

  const handlePlaceChanged = useCallback(() => {
    if (!autocompleteRef.current) return;
    const place = autocompleteRef.current.getPlace();
    if (!place.address_components) return;

    const get = (type, form = "long_name") => {
      const comp = place.address_components.find((c) =>
        c.types.includes(type)
      );
      return comp ? comp[form] : "";
    };

    const streetNumber = get("street_number");
    const route = get("route");
    const address1 = [streetNumber, route].filter(Boolean).join(" ");

    setFieldValue(`${fieldPrefix}_address_1`, address1);
    setFieldValue(
      `${fieldPrefix}_city`,
      get("locality") || get("sublocality_level_1")
    );
    setFieldValue(
      `${fieldPrefix}_state`,
      get("administrative_area_level_1", "short_name")
    );
    setFieldValue(`${fieldPrefix}_country`, get("country", "short_name"));
    setFieldValue(`${fieldPrefix}_postcode`, get("postal_code"));
  }, [fieldPrefix, setFieldValue]);

  const handleLoad = useCallback((autocomplete) => {
    autocompleteRef.current = autocomplete;
  }, []);

  if (!isLoaded) {
    return (
      <TextField
        name={name}
        value={value}
        onChange={onChange}
        {...textFieldProps}
      />
    );
  }

  return (
    <Autocomplete
      onLoad={handleLoad}
      onPlaceChanged={handlePlaceChanged}
      options={{
        types: ["address"],
        componentRestrictions: { country: ["au", "nz"] },
      }}
    >
      <TextField
        name={name}
        value={value}
        onChange={onChange}
        {...textFieldProps}
      />
    </Autocomplete>
  );
};

export default AddressAutocomplete;
